import { constants } from "@newsela/angelou";

const greyLight = constants.colors.ui.neutral[100];

export const dividerCss = {
  borderBottom: `1px solid ${greyLight}`,
};

export const responseItemContainerCss = {
  width: "100%",
  maxWidth: "327px",
  margin: "0 auto",
};
